module.exports = __webpack_public_path__ + "static/media/partner_Technicians_at_Work.80542991.png";